import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BrowserModule } from '@angular/platform-browser';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { TabViewComponent } from '../tab-view/tab-view.component';
import { AngularMultiSelectModule } from 'angular2-multiselect-dropdown';

@NgModule({
  declarations: [TabViewComponent],
  imports: [
    CommonModule,
    BrowserModule,
    NgbModule,
    AngularMultiSelectModule
  ],
  exports: [TabViewComponent],
  entryComponents: []
})
export class TabViewModuleModule { }
